import {
  BOGGLE_LETTER_WEIGHTS,
  flattenBoggleLetterWeights,
} from './boardDistributions/letterWeights'

const BOGGLE_CHALLENGE_VOWEL_VALUES = ['A', 'E', 'I', 'O', 'U'] as const
export const BOGGLE_CHALLENGE_VOWELS = new Set<string>(BOGGLE_CHALLENGE_VOWEL_VALUES)
const FLATTENED_LETTER_WEIGHTS = flattenBoggleLetterWeights(BOGGLE_LETTER_WEIGHTS)
const BOGGLE_SPAWNABLE_LETTER_VALUES = FLATTENED_LETTER_WEIGHTS.filter(([, weight]) => weight > 0).map(
  ([letter]) => letter,
)
export const BOGGLE_COMMON_LETTER_VALUES = ['T', 'L', 'R', 'N', 'S'] as const
export const BOGGLE_UNCOMMON_LETTERS = ['Q', 'V', 'K', 'B', 'U', 'J', 'W', 'X', 'Z'] as const
export const BOGGLE_ANCHOR_LETTER_ALLOWED_VALUES: readonly string[] =
  BOGGLE_SPAWNABLE_LETTER_VALUES.filter(letter => !BOGGLE_CHALLENGE_VOWELS.has(letter))
export const BOGGLE_MORE_COMMON_LETTER_ALLOWED_VALUES = FLATTENED_LETTER_WEIGHTS.filter(
  ([letter, weight]) => !BOGGLE_CHALLENGE_VOWELS.has(letter) && weight > 0,
).map(([letter]) => letter)
export const BOGGLE_VOWEL_PARING_ALLOWED_VALUES = ['A/E', 'I/E', 'O/E', 'A/I', 'A/O', 'A/U', 'O/U'] as const
